import { ClerkLoading, SignedIn, SignedOut } from "@clerk/clerk-react";
import type { ReactNode } from "react";
import { AuthLoading } from "./AuthLoading";
import { AuthScreen } from "./AuthScreen";

/** Host-only gate for editor routes. Guest `/i/:code` stays outside this wrapper. */
export function RequireHostAuth({ children }: { children: ReactNode }) {
  return (
    <>
      <ClerkLoading>
        <AuthLoading />
      </ClerkLoading>
      <SignedOut>
        <AuthScreen mode="sign-in" redirectUrl={window.location.href.split("#")[0]} />
      </SignedOut>
      <SignedIn>{children}</SignedIn>
    </>
  );
}
